<template>
    <div class="pt-8">
        <b-row> 
            <b-col cols="12" md="6" v-if="canSeeTopSellingItems" class="mb-3 mb-md-0">
                <top-selling-items />
            </b-col>

            <b-col cols="12" md="6" v-if="canSeeTopSellingCompanies" class="mb-3 mb-md-0">
                <top-selling-companies />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import TopSellingItems from '../components/TopSellingItems.vue'
import TopSellingCompanies from '../components/TopSellingCompanies.vue'

import { mapState } from 'vuex'

export default {
    components: {
        TopSellingItems,
        TopSellingCompanies
        
    },
    computed: {
        ...mapState('auth', ['user']),
        canSeeTopSellingItems() {
            //return this.user.permissions.includes('can_see_top_selling_items');
            return this.user.isAdmin === 1;
        },
        canSeeTopSellingCompanies() {
            //return this.user.permissions.includes('can_see_top_seller');
            return this.user.isAdmin === 1;
        }
    },
    data() {
        return {
        };
    },
    methods: {
       
    }
}
</script>
